import React from 'react';
import PropTypes from 'prop-types';

const FontIcon = ({ 
  name,
  size = '16px',
  color,
  className = '',
  style = {},
  onClick,
  ...props 
}) => {
  // 处理图标名称和前缀
  let iconName = name;
  let prefix = 'fas'; // 默认使用 fas (solid) 前缀
  
  // 品牌图标使用 fab 前缀
  const brandIcons = [
    'weixin', 'qq', 'weibo', 'alipay', 'facebook', 'twitter', 'google', 'github', 'apple',
    'chrome', 'firefox', 'safari', 'edge', 'opera', 'internet-explorer'
  ];
  if (brandIcons.includes(name)) {
    prefix = 'fab';
  }
  
  // 确保图标名称格式正确
  if (!iconName.startsWith('fa-')) {
    iconName = `fa-${iconName}`;
  }
  
  // 构建最终的类名
  const baseClassName = `${prefix} ${iconName}`;
  
  return (
    <i 
      className={`${baseClassName} ${className}`.trim()}
      style={{ 
        fontSize: size,
        width: size,
        height: size,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color,
        ...style
      }}
      onClick={onClick}
      {...props}
    />
  );
};

FontIcon.propTypes = {
  name: PropTypes.string.isRequired,      // 图标名称，例如: 'plus' 或 'fa-plus'
  size: PropTypes.string,                 // 图标大小，例如: '16px'
  color: PropTypes.string,                // 图标颜色
  className: PropTypes.string,            // 额外的类名
  style: PropTypes.object,                // 额外的样式
  onClick: PropTypes.func                 // 点击事件处理函数
};

export default FontIcon; 